/**
 * @flow
 * @relayHash 785290c0d9a87b43cb2839aa0e953558
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ShipmentStatus = "DELIVERED" | "DRAFT" | "READY" | "SHIPPED";
export type UpdateShipmentInput = {|
  id: string,
  orderId?: ?string,
  customerId?: ?string,
  status?: ?ShipmentStatus,
  carrierName?: ?string,
  trackingNumber?: ?string,
  shippingMethod?: ?string,
  shippingAddressLine1?: ?string,
  shippingAddressLine2?: ?string,
  shippingAddressLine3?: ?string,
  shippingAddressCity?: ?string,
  shippingAddressState?: ?string,
  shippingAddressZip?: ?string,
  estimatedShipDate?: ?any,
  actualShipDate?: ?any,
  estimatedDeliveryDate?: ?any,
  actualDeliveryDate?: ?any,
  notes?: ?string,
  packageWeight?: ?number,
  packageLength?: ?number,
  packageWidth?: ?number,
  packageHeight?: ?number,
|};
export type UpdateShipmentMutationVariables = {|
  input: UpdateShipmentInput
|};
export type UpdateShipmentMutationResponse = {|
  +updateShipment: {|
    +error: ?string,
    +shipmentEdge: {|
      +node: {|
        +id: string,
        +shipmentNumber: string,
        +status: ShipmentStatus,
        +carrierName: ?string,
        +trackingNumber: ?string,
        +shippingMethod: ?string,
        +shippingAddressLine1: ?string,
        +shippingAddressLine2: ?string,
        +shippingAddressLine3: ?string,
        +shippingAddressCity: ?string,
        +shippingAddressState: ?string,
        +shippingAddressZip: ?string,
        +estimatedShipDate: ?any,
        +actualShipDate: ?any,
        +estimatedDeliveryDate: ?any,
        +actualDeliveryDate: ?any,
        +notes: ?string,
        +packageWeight: ?number,
        +packageLength: ?number,
        +packageWidth: ?number,
        +packageHeight: ?number,
        +shippingCost: ?number,
        +serviceType: ?string,
        +serviceName: ?string,
        +shippingLabelUrl: ?string,
        +upsShipmentId: ?string,
        +order: {|
          +id: string,
          +orderNumber: string,
        |},
        +customer: {|
          +id: string,
          +name: string,
        |},
        +updatedAt: any,
        +createdAt: any,
      |}
    |},
  |}
|};
export type UpdateShipmentMutation = {|
  variables: UpdateShipmentMutationVariables,
  response: UpdateShipmentMutationResponse,
|};
*/


/*
mutation UpdateShipmentMutation(
  $input: UpdateShipmentInput!
) {
  updateShipment(input: $input) {
    error
    shipmentEdge {
      node {
        id
        shipmentNumber
        status
        carrierName
        trackingNumber
        shippingMethod
        shippingAddressLine1
        shippingAddressLine2
        shippingAddressLine3
        shippingAddressCity
        shippingAddressState
        shippingAddressZip
        estimatedShipDate
        actualShipDate
        estimatedDeliveryDate
        actualDeliveryDate
        notes
        packageWeight
        packageLength
        packageWidth
        packageHeight
        shippingCost
        serviceType
        serviceName
        shippingLabelUrl
        upsShipmentId
        order {
          id
          orderNumber
        }
        customer {
          id
          name
        }
        updatedAt
        createdAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateShipmentInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateShipment",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateShipmentPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "shipmentEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "ShipmentEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Shipment",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shipmentNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "carrierName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "trackingNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingMethod",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressLine1",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressLine2",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressLine3",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressCity",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressState",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressZip",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "estimatedShipDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "actualShipDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "estimatedDeliveryDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "actualDeliveryDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "notes",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "packageWeight",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "packageLength",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "packageWidth",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "packageHeight",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingCost",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "serviceType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "serviceName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingLabelUrl",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "upsShipmentId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "order",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "orderNumber",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "customer",
                "storageKey": null,
                "args": null,
                "concreteType": "Customer",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "updatedAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateShipmentMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateShipmentMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateShipmentMutation",
    "id": null,
    "text": "mutation UpdateShipmentMutation(\n  $input: UpdateShipmentInput!\n) {\n  updateShipment(input: $input) {\n    error\n    shipmentEdge {\n      node {\n        id\n        shipmentNumber\n        status\n        carrierName\n        trackingNumber\n        shippingMethod\n        shippingAddressLine1\n        shippingAddressLine2\n        shippingAddressLine3\n        shippingAddressCity\n        shippingAddressState\n        shippingAddressZip\n        estimatedShipDate\n        actualShipDate\n        estimatedDeliveryDate\n        actualDeliveryDate\n        notes\n        packageWeight\n        packageLength\n        packageWidth\n        packageHeight\n        shippingCost\n        serviceType\n        serviceName\n        shippingLabelUrl\n        upsShipmentId\n        order {\n          id\n          orderNumber\n        }\n        customer {\n          id\n          name\n        }\n        updatedAt\n        createdAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cdab3beb0642360ed0b49017bb4dc0d7';
module.exports = node;
